import React from 'react'
import { useContext } from 'react'
import { GeometryContext } from '../store/store'
import {RigidBody, CuboidCollider} from '@react-three/rapier'
import {useSelector} from 'react-redux'

const Bounds = ({length = 1}) => {
    const geometryCtx = useContext(GeometryContext)
    // const geometryState = useSelector((state)=>state.geometry)
    return (
        <group>
            <RigidBody type='fixed' restitution={0.2} friction={0}>
                <mesh
                    geometry={geometryCtx.boxGeometry}
                    material={geometryCtx.wallMaterial}
                    scale={[0.3, 1.5, 4 * length]}
                    position={[2.15,0.75,-(length *2) + 2]}
                    castShadow
                />
                <mesh
                    geometry={geometryCtx.boxGeometry}
                    material={geometryCtx.wallMaterial}
                    scale={[0.3, 1.5, 4 * length]}
                    position={[-2.15,0.75,-(length *2) + 2]}
                    receiveShadow
                />
                <mesh
                    geometry={geometryCtx.boxGeometry}
                    material={geometryCtx.wallMaterial}
                    scale={[4, 1.5, 0.3]}
                    position={[0,0.75,-(length *4) + 2]}
                    receiveShadow
                />
                <CuboidCollider
                    args={[2,0.1,2 * length]}
                    position={[0,-0.1, -(length * 2) + 2]}
                    restitution={0.2}
                    friction={1}
                />
            </RigidBody>
        </group>
    )
}

export default Bounds